import React from 'react';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {PATHS} from 'Routes';
import {device} from '@guestapp/ui/src/utils/device';
import {useSummary} from 'context/summary';
import {useFetchLocks, usePath, useScreenResize} from 'hooks';
import keyIconCircle from 'assets/icons/remote-access-key-icon-circle.svg';
import Page from 'components/Page';
// import {CheckInCompleteModal} from 'components/CheckInCompleteModal/CheckInCompleteModal';
import HomeBookingStatusPanel from 'components/HomeBookingStatusPanel';
import TasksPanel from 'components/TasksPanel';
import NavigationItem from 'components/NavigationItem';
import {
  BookingAndButtonContainer,
  BoxTitle,
  DesktopMainButton,
  MobileMainButton,
  StyledBox,
  StyledHr,
  StyledIcon,
  TaskInfoContainer,
  TasksPanelContainer,
  WelcomeText,
  Wrapper,
} from './styled';

function HomeView() {
  const {t} = useTranslation();
  const {isLoading, isGuestRegistrationOnly, data} = useSummary();
  const {locks} = useFetchLocks({
    enabled: Boolean(data?.is_remote_access_enabled),
  });
  const navigate = useNavigate();
  const {getFullPath} = usePath();
  const {isMatch: isMobileMode} = useScreenResize(device.tabletSubHeader);

  const nextBtnProps = React.useMemo(() => {
    const pathToRedirect = isGuestRegistrationOnly
      ? PATHS.guestRegistration
      : PATHS.summary;

    return {
      label: t('go_to_chekin'),
      customIcon: <StyledIcon name="backArrow" color="#fff" size={16} />,
      onClick: () => navigate(pathToRedirect),
    };
  }, [t, navigate, isGuestRegistrationOnly]);

  return (
    <>
      <Page
        mainHeader
        title={t('confirm_booking_details')}
        isLoading={isLoading}
        navBarTitle={isMobileMode ? undefined : `${t('welcome')}!`}
        className="home-view"
      >
        <Wrapper className="home-view__content">
          {isMobileMode && (
            <WelcomeText className="home-view__welcome">{t('welcome')}</WelcomeText>
          )}
          <StyledBox className="home-info-box">
            <BoxTitle className="home-info-box__title">{t('online_chekin')}</BoxTitle>
            <TaskInfoContainer>
              <BookingAndButtonContainer className="home-info-box__booking">
                <HomeBookingStatusPanel />
                <DesktopMainButton {...nextBtnProps} />
              </BookingAndButtonContainer>
              <StyledHr />
              <TasksPanelContainer className="home-info-box__tasks">
                <TasksPanel />
              </TasksPanelContainer>
              <MobileMainButton {...nextBtnProps} />
            </TaskInfoContainer>
          </StyledBox>
        </Wrapper>
        {data?.is_remote_access_enabled && locks?.is_show_keys_enabled && (
          <NavigationItem
            maxWidth="100%"
            title={t('virtual_keys')}
            path={getFullPath(PATHS.remoteAccess)}
            icon={keyIconCircle}
            isStatusBoxVisible={false}
            description={t('direct_access_you_virtual_keys')}
          />
        )}
      </Page>
    </>
  );
}

export {HomeView};
